export default __webpack_public_path__ + "static/media/arrow_3.53315ea6.svg";